import styled from 'styled-components';
import { fontFamilySize, px } from '../../../../../../contrib/ui';

export const ScoringFormatStyled = styled.div`
  .scoring-format {
    width: 100%;
    display: flex;
    flex-direction: row;
    align-items: center;

    p {
      margin-top: 0;
      margin-right: ${px(50)};
    }
  }

  .stableford-score-values {
    p.format-label {
      margin-top: ${px(15)} !important;
      margin-bottom: ${px(15)} !important;
    }

    .selectors-container {
      width: 100%;
      display: flex;
      flex-direction: row;
      justify-content: space-evenly;

      .selector {
        display: flex;
        flex-direction: column;
        width: ${px(100)};

        p {
          width: 100%;
          text-align: center;
          line-height: 1.2;
          height: ${px(35)};
          margin: 0;

          ${fontFamilySize('Bold', 12)};
        }

        .input-form-control {
          padding-left: ${px(10)};
          padding-right: ${px(10)};

          .material-input {
            margin-top: 0;

            input {
              width: 100%;
              text-align: center;
            }
          }
        }
      }
    }
  }
`;
